import { module } from "modujs";
import * as cart from '@shopify/theme-cart';
import { html } from "../utils/environment";
import { inertElements } from "../utils/inertElements";
import VueCart from "../vue/components/VueCart";
import VueCartItem from "../vue/components/VueCartItem";
import VueQuantityInput from "../vue/components/VueQuantityInput";

export default class extends module {
    constructor(m) {
        super(m);

        // Binding
        this.onEscapeBind = (e) => {
            if (
                e.key === "Escape" &&
                html.classList.contains("has-cart-open")
            ) {
                this.close();
            }
        };

        // Data
        this.isCartModal = (this.el.dataset.moduleCart === "cartModal")
        this.isCartPage = (this.el.dataset.moduleCart === "cartPage")

        // UI
        this.$el = this.el;

        // Inert
        this.elementsToUnfocus = ['[data-load-container]', '.c-header-tool', '.c-footer', '.c-splash', '.c-search-bar']
        this.elementsToFocus = ['.c-cart']
    }

    ///////////////
    // Lifecyle
    ///////////////
    init() {
        this.bindEvents();

        // Init vue
        this.initVue();

        // Initial cart
        this.getInitialCart();

        // Inert
        // inertElements(this.elementsToFocus, true)
    }

    destroy() {
        super.destroy();
        this.unbindEvents();
        this.app?.$destroy?.();
    }

    ///////////////
    // Events
    ///////////////
    bindEvents() {
        document.addEventListener('keyup', this.onEscapeBind)

        this.manifoldCartUpdatedBind = this.manifoldCartUpdate.bind(this)
        window.addEventListener('m-campaign_cart_updated', this.manifoldCartUpdatedBind)
    }

    unbindEvents() {
        document.removeEventListener('keyup', this.onEscapeBind)
        window.removeEventListener('m-campaign_cart_updated', this.manifoldCartUpdatedBind)
    }

    ///////////////
    // Display
    toggle() {
        if (html.classList.contains("has-cart-open")) {
            this.close();

            if (this.isCartModal) {
                this.call('getLatestCart', null, 'Cart', 'cartPage')
            }
        } else {
            this.open();

            if (this.isCartModal) {
                this.getLatestCart()
            }
        }
    }

    open() {
        html.classList.add("has-cart-open")

        inertElements(this.elementsToUnfocus, true)

        inertElements(this.elementsToFocus, false)
    }

    close() {
        html.classList.remove("has-cart-open")

        inertElements(this.elementsToUnfocus, false)

        inertElements(this.elementsToFocus, true)
    }

    ///////////////
    // Data

    /**
     * Retrieve cart state
     *
     * @param
     */
    refreshCart() {
        return cart.getState().then(state => {
            this.updateCart(state);
        })
    }

    getLatestCart() {
        this.refreshCart();
    }

    getInitialCart() {
        this.refreshCart();
    }

    manifoldCartUpdate() {
        return cart.getState().then(state => {
            this.updateCart(state);
            this.open();
        })
    }

    /**
     * Add item to cart with variant ID
     *
     * @param {id}
     */
     addItem({id,quantity}) {
        cart.addItem(id, {quantity}).then((item) => {
            console.log(
                `An item with a quantity of ${quantity} was added to your cart:`,
                item
            )

            this.refreshCart().then(() => {
                this.open()
            })
        })
    }

    /**
     * Remove item
     *
     * @param
     */
    removeItem(key) {
        cart.removeItem(key).then(state => {
            console.log(`There is now ${state.items.length} item(s) in your cart`);

            this.refreshCart().then(() => {
                //callback
            })
        })
    }

    updateCart(cart) {
        // Update cart data
        this.app && this.app.$refs.cart && this.app.$refs.cart.setCartData(cart)

        // Update total
        this.call('updateTotal', cart, 'CartTotal')

        // Update cart counter
        this.call('setCartCounter', cart, 'CartCounter')
    }

    toggleClass(hasTokenGatedProducts) {
        const cartEl = document.querySelector('.c-cart')

        if(hasTokenGatedProducts) {
            cartEl.classList.add('has-token-gated-products')
        } else {
            cartEl.classList.remove('has-token-gated-products')
        }
    }

    /////////////////////////
    // Vue Instance
    initVue() {
        /////////////////////////
        // Save moduleInstance
        const moduleInstance = this

        /////////////////////////
        // Settings
        Vue.config.devtools = true

        /////////////////////////
        // Vue Components
        VueCart(moduleInstance)
        VueCartItem()
        VueQuantityInput()

        /////////////////////////
        // Vue Instance
        this.app = new Vue({
            el: this.el
        });
    }
}
